window.SettingsAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsCoreServersBaseURL : publicConfiguration.APIServerBaseURL);

    _protected.CACHING_TIMEOUT = 1000; // Caching for one second only

    self.SBML_USER_PERMISSIONS = {
      CAN_POST:{
        name: $filter("translate")("manager can post jobs freely"),
        code: 'CAN_POST'
      },
      CAN_POST_TEMPLATE:{
        name: $filter("translate")("manager can only post job from admin templates"),
        code: 'CAN_POST_TEMPLATE'
      },
      CANNOT_POST:{
        name: $filter("translate")("cannot post jobs"),
        code: 'CANNOT_POST'
      }
    };

    /**
     * Validate email if it's a user on the system or not
     * @returns {deferred.promise|{then, always}|{then}}
    */
    self.validateEmail = function (email) {
        var deferred = $q.defer();

        var requestPayload = {};
        requestPayload.email = email;

        _protected.request('registration/validateEmail', 'POST', requestPayload).then(function(res) {
            if(res && res.data && res.data.status_code && res.data.status_code == 200){
                deferred.resolve(true);
            }else{
                deferred.resolve(false);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    self.checkUserToken = function (token) {
        var deferred = $q.defer();

        _protected.request("light_signup", "GET", {code: token})
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        if (res.data.data.is_consumed) {
                            deferred.reject({code: 'ALREADY_ACTIVATED'});
                        } else {
                            deferred.resolve(res.data.data);
                        }
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * Validate admin account if it's applicable to be added or not
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.validateBrandAdminEmail = function (email) {
      var deferred = $q.defer();

      var requestPayload = {};
      requestPayload.email = email;

      _protected.request('brand_admin/validate_email', 'POST', requestPayload).then(function(res) {
        if(res && res.data && res.data.status_code && res.data.status_code == 200){
          deferred.resolve(res.data.data);
        }else{
          deferred.reject(res.data.data);
        }

      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

	/**
	 * check if email exists and if it belongs to EMPLOYER or JOB_SEEKER
	 * @param email
	 * @returns {deferred.promise|{then, always}|{then}}
	 */
	self.checkUserTypeIfExists = function (email, brandId) {
		var deferred = $q.defer();

		var requestPayload = {};
		requestPayload.email = email;
		requestPayload.brand_id = brandId;

		_protected.request('users/type', 'GET', requestPayload).then(function(res) {
			if(res && res.data && res.data.status_code && res.data.status_code == 200){
				deferred.resolve(res.data.data);
			}else{
				deferred.reject(res.data.data);
			}

		}, function (err) {
			deferred.reject(err);
		});

		return deferred.promise;
	};

    /**
     * Add new manager to a brand
     * @returns {deferred.promise|{then, always}|{then}}
    */
    self.addBrandAdmin = function (brand_ids, user,permission) {
        var deferred = $q.defer();

        var requestPayload = {};
        requestPayload.brand_ids = brand_ids;
        requestPayload.permission = permission;
        if(user.email){
            requestPayload.email = user.email;
        }
        if(user.user_email){
            requestPayload.user_email = user.user_email;
        }
        if(user.first_name){
            requestPayload.first_name = user.first_name;
        }
        if(user.last_name){
            requestPayload.last_name = user.last_name;
        }
        _protected.request('brand_admin', 'PUT', requestPayload).then(function(res) {
            if(res && res.data && res.data.status_code && res.data.status_code == 200){
                deferred.resolve(res.data);
            }else{
                deferred.reject(res);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * Get User Permissions
     * @returns {deferred.promise|{then, always}|{then}}
    */
    self.getUserPermissions = function () {
        var deferred = $q.defer();

        _protected.request('user_permissions', 'GET').then(function(res) {
            deferred.resolve(res.data.data);
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /**
     * Get a manager permission
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getManagerPermission = function (managerId,brandId) {
      var deferred = $q.defer();

      var reqPayload = {};
      reqPayload.manager_id = managerId;
      reqPayload.door_id = brandId;

      _protected.request('user_permissions', 'POST',reqPayload).then(function(res) {
        deferred.resolve(res.data.data);
      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };

    /**
     * Update Manager Permission
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.updateManagerPermission = function (manager_id,door_id,permission) {
      var deferred = $q.defer();

      var reqPayload = {};
      reqPayload.manager_id = manager_id;
      reqPayload.door_id = door_id;
      reqPayload.permission = permission;

      _protected.request('user_permissions', 'PUT',reqPayload).then(function(res) {
        if(res && res.data && res.data.status_code == 200){
          deferred.resolve(res.data.data);
        }else{
          deferred.reject(res);
        }
      }, function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    };
    /**
     * Update User Password
     * @returns {deferred.promise|{then, always}|{then}}
    */
    self.updateUserPassword = function (oldPassword, password,confirmPassword) {

        var requestPayload = {};
        requestPayload.old_password = oldPassword;
        requestPayload.new_password = password;
        requestPayload.confirm_new_password = confirmPassword;

        var deferred = $q.defer();

        _protected.request('users/changePassword', 'POST',requestPayload).then(function(res) {
            if(res && res.data && res.data.status_code == 200){
                deferred.resolve(res.data.data);
            }
            else{
                deferred.reject(res.data.data);
            }
        }, function (err) {
            deferred.reject(err.data.data);
        });

        return deferred.promise;
    };

    self.loadPersonalInformation = function() {
        var deferred = $q.defer();

        var cached = _protected.getCached("current");

        if (cached) {
            deferred.resolve(cached);
        }
        else {
        _protected.request('user', 'GET')
            .then(function(res) {
                if(res && res.data && res.data.status_code == 200){
                    _protected.cache("current", res.data.data);
                    deferred.resolve(res.data.data);
                }
                else{
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });
        }

        return deferred.promise;
    }

    self.savePersonalInformation = function(data) {
        var deferred = $q.defer();

        _protected.request('user', 'POST', data)
            .then(function(res) {
                if(res && res.data && res.data.status_code == 200){
                    deferred.resolve(res.data.data);
                }
                else{
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.loadUserEducation = function(userId) {
        var deferred = $q.defer();

        _protected.request('user_education/' + userId, 'GET')
            .then(function(res) {
                var education = [];

                if(res && res.data && res.data.status_code == 200) {

                    for (var i in res.data.data) {
                        education.push(angular.copy(res.data.data[i].UserEducation));
                    }

                    deferred.resolve(education);
                }
                else{
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.saveUserEducation = function (googleMaps, userId, educations, educationsToDelete, type) {
        var deferred = $q.defer();

        var promises = [];

        educations.forEach((education, index) => {

            var educationDefer = $q.defer();

            if (!education || !education.Institution) {
                console.warn("Invalid education:", education);
                educationDefer.reject("Invalid education:");
                return;
            }

            var isNewEducation = !education.id;

            var instituteSource;

            if (!education.Institution.value && education.Institution.label) {
                instituteSource = "TEXT";
                education.Institution.value = education.google_location;
            }
            else if (education.Institution.type == "Google") {
                instituteSource = "GOOGLE";
            }
            else if (education.Institution.label && education.Institution.value && education.Institution.value.id) {
                instituteSource = "SAME";
            }
            else {
                console.warn("Unexpected institution source:", education);
                educationDefer.reject("Unexpected institution source:");
                return;
            }



            var institutionDefer = $q.defer();

            var educationData = {
                'education_id': education.id,
                'discipline': education.DisciplineLookup.name,
                'degree_id': education.DegreeLookup.id,
                'end_date': education.end_date,
                'start_date': education.start_date,
            };

            var educationUpdateAPI = "user/education";
            var educationUpdateMethod = "PUT";

            if (!isNewEducation) {
                educationUpdateMethod = "POST";
            }

            switch (instituteSource) {
                case "TEXT":
                    educationData['institution_name'] = education.Institution.label;
                    educationData['google_location'] = education.google_location;
                    institutionDefer.resolve();
                    break;
                case "GOOGLE":
                    googleMaps.getDetails({placeId: education.Institution.value.place_id}, function (res) {
                        educationData['google_place'] = {'result': res};
                        institutionDefer.resolve();
                    })
                    break;
                case "SAME":
                    institutionDefer.resolve();
                    break;
            }

            if (education.still_in_school) {
                delete educationData.end_date;
            }

            if (type === 'job_application' && educationUpdateMethod === 'PUT' && index === 0) {
                educationData.force = true;
            }

            institutionDefer.promise.then(function () {
                _protected.request(educationUpdateAPI, educationUpdateMethod, [educationData])
                    .then(function (res) {

                        if (!educationData.education_id && res.data && res.data.data) {
                            education.id = res.data.data[0].id;
                        }

                        educationDefer.resolve(educationData);
                    });
            });

            promises.push(educationDefer.promise);
        });

        educationsToDelete.forEach(function(education) {

            var educationDefer = $q.defer();
            promises.push(educationDefer.promise);

            if (education.id) {
                _protected.request("user_education/" + education.id, "DELETE")
                    .then(function(){
                        educationDefer.resolve();
                    });
            }
            else {
                console.warn("Unexpected education to be deleted:", education);
            }
        });

        $q.all(promises).then(function(result) {
            deferred.resolve(result);
        });

        return deferred.promise;
    }


    self.loadUserExperience = function() {
        var deferred = $q.defer();

        _protected.request('work_history', 'GET')
            .then(function(res) {
                var experience = [];

                if(res && res.data && res.data.status_code == 200) {
                    if (res.data.data.first_job){
                      deferred.resolve(res.data.data);
                    } else {
                      for (var i in res.data.data) {
                        experience.push(res.data.data[i].Work);
                      }

                      deferred.resolve(experience);
                    }
                }
                else{
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }


    /**
     * @Description [ add new user experiences for user work history ]
     * @param userExperiences
     * @param firstJob
     * @param userExperiencesToDelete
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.addUserExperience = function (userExperiences, firstJob, userExperiencesToDelete, isJobApplicationForm){


      var deferred       = {},
          experiences    = [],
          googlePromises = [],
          googleMaps     = getAngularService('googleMaps');

      /**
       * [creat new work history object]
       * @param experience
       */
      var creatUserWorkHistory = function (experience) {
        var work_history = {};

        work_history.allow_to_contact_reference = (experience.allow_to_contact_reference == "yes") ? true : false;

        // condition && expression insted of if(conditon) expression

        experience.brand && experience.brand.brand_name && (work_history.brand_name = experience.brand.brand_name);

        experience.end_date && !experience.still_work_here && (work_history.end_date = experience.end_date);

        experience.start_date && (work_history.start_date = experience.start_date);

        experience.phone && (work_history.phone = experience.phone);

        experience.reason_for_leaving && (work_history.reason_for_leaving = experience.reason_for_leaving);

        experience.description && (work_history.work_description = experience.description);

        experience.supervisor && (work_history.supervisor = experience.supervisor);

        experience.position?.id && (work_history.position_id = experience.position.id);

        experience.position?.custom_position && (work_history.custom_position = experience.position?.custom_position);

        experience.still_work_here && (work_history.present = experience.still_work_here);

        experience.google_location && (work_history.google_location = experience.google_location);

        return work_history;
      };
      // end creatUserWorkHistory


      /**
       * [InsertAsFirstJob to insert the job without any work History]
       */
      var InsertAsFirstJob = function () {

        var firstJobDefer = $q.defer();

        _protected.request('user/work_history', 'PUT', [{"first_job": true}])
          .then(function(data){
            firstJobDefer.resolve(data);
          }, function(err){
            firstJobDefer.reject();
          });

        return firstJobDefer.promise
      };
      // end InsertAsFirstJob


      /**
       * [ get google place for some location ]
       * @param experience
       * @param work_history
       * @returns {new work_history with google place}
       */
      var getGooglePlaceObject = function (experience, work_history) {

        var googlePromise = $q.defer();

        if (experience.brand && experience.brand.value)
        {
          var placeId = experience.brand.value.place_id;

          googleMaps.getDetails({placeId: placeId}, function (r) {
            work_history.google_place = {result: r};
            googlePromise.resolve();
          });

          googlePromises.push(googlePromise.promise);
        }

        return work_history;
      };
      // end getGooglePlaceObject


      /**
       * [ delete the user experiences that not needed ]
       * @param userExperiencesDelete
       * @returns {promise}
       */
      var deleteExperiences = function (userExperiencesDelete) {

        var userExperiencesDeleteDefer = $q.defer();

        var deleted = { "work_history_ids" : userExperiencesDelete }

        _protected.request("user/delete_work_history", 'POST', deleted)
          .then(function(res){
            userExperiencesDeleteDefer.resolve(res);
          });

        return userExperiencesDeleteDefer.promise;
      };
      // end userExperiencesDelete


      if (firstJob)
      {
          deferred['first_job'] = InsertAsFirstJob();
      }
      else
      {
        userExperiences.forEach(function (experience, index) {

          var work_history = creatUserWorkHistory(experience);

          if (!experience.id)
          {
            work_history = getGooglePlaceObject(experience, work_history);
          }

          if (experience.id)
          {
            var googlePromise = $q.defer();

            if (experience.brand && experience.brand.value)
            {
              (function (place_id, work_history) {
                googleMaps.getDetails({placeId: place_id}, function (r) {
                  work_history.google_place = {result: r};
                  googlePromise.resolve();
                });
              })(experience.brand.value.place_id, work_history);
            }
            else
            {
              googlePromise.resolve();
            }

            work_history.work_id = experience.id;

            var editPromise = $q.defer();

            googlePromise.promise.then(function (){
              _protected.request('user/work_history', 'POST', [work_history])
                .then(function(data){
                  editPromise.resolve(data);
                }, function(err){
                  editPromise.reject(err);
                });
            });

            googlePromises.push(editPromise.promise);
          }
          else {
              if (isJobApplicationForm && index === 0) {
                  work_history.force = true;
              }
              experiences.push(work_history);
          }
        });

          var experDeffer = $q.defer();

          $q.all(googlePromises).then(function (data){

              if (experiences.length > 0 && !firstJob) {
                  _protected.request('user/work_history', 'PUT', experiences)
                      .then(function(data){
                          experDeffer.resolve(data);
                      }, function(err){
                          experDeffer.reject(err);
                      });
              } else {
                  experDeffer.resolve();
              }

          });

          deferred['add'] = experDeffer.promise;
      }

      if (userExperiencesToDelete.length > 0) {
          deferred['delete'] = deleteExperiences(userExperiencesToDelete);
      }

      return $q.all(deferred);
    };

    /**
     * @Description [return promise for add new answers brand Questions]
     * @param brandQuestions
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.addAnswersForBrandQuestion = function (brandQuestions, idObj) {
      var deferred = $q.defer();

      var brandsQ = [];

      for (var key in brandQuestions)
      {
          if (key == "2") {
              var d = new Date(brandQuestions[2].answer);
              brandQuestions[2].answer == d.toUTCString();
          }

          var object = {
              code : key,
              answer : brandQuestions[key].answer || ""
          };

          brandsQ.push(object);
      };

      var brandToSend = {
        answers : brandsQ
      };

        if (idObj.applicationId) {
            _protected.request(publicConfiguration.OnboardingServerBaseURL + 'second_phase/' + idObj.applicationId, 'POST', brandToSend)
                .then(function (res) {
                    deferred.resolve();
                });
        }
        else if (idObj.documentId){
            _protected.request(publicConfiguration.OnboardingServerBaseURL + 'second_phase/' + idObj.documentId, 'PUT', brandToSend)
                .then(function (res) {
                    deferred.resolve();
                });
        }
        else {
            console.error("Application or Document id is needed");
        }


      return deferred.promise;
    };

  /**
   * @Description [load the user answers for brand questions]
   * @param jobApplicationId
   * @returns {deferred.promise|{then, always}|{then}}
   */
    self.loadAnswersForBrandQuestion = function (brandId){
      var deferred = $q.defer();

      _protected.request(publicConfiguration.OnboardingServerBaseURL + 'second_phase/questions/' + brandId, 'GET')
        .then(function(res) {

          if(res && res.data && res.data.status_code == 200) {
            deferred.resolve(res.data);
          }
          else{
            deferred.reject(res);
          }
        },
        function (err) {
          deferred.reject(err);
        });

      return deferred.promise;
    };

    self.saveSecondPhase = function (applicationId, email) {
        var deferred = $q.defer();

        _protected.request(`${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}digital_application/${applicationId}`, 'POST', {"job_application_id" : applicationId, "email": email})
            .then(function(res) {

                if(res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else{
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Set Video as Primiary, in media settings
     *
     * @param videoId
     * @returns {deferred.promise|{then, always}}
     */
    self.setPrimaryVideo = function (videoId, brandId) {

        var deferred = $q.defer();

        var requestPayload = {
            media_id : videoId,
            brand_id : brandId
        };

        _protected.request('brand_media/set_primary', 'POST', requestPayload)
            .then(function(res) {
                if(res && res.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                }
                else{
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };


  /**
   * Get reviews settings for a Brand
   *
   * @param brandId
   * @returns {deferred.promise|{then, always}}
   */
    self.getBrandReviewsSettings = function(brandId) {

      var deferred = $q.defer();

      _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brand/reviews_settings/' + brandId, 'GET')
          .then(function(res) {
            if(res && res.data && res.data.status_code == 200) {
              deferred.resolve(res.data.data);
            }
            else{
              deferred.reject(res);
            }
          },
          function (err) {
            deferred.reject(err);
          });

      return deferred.promise;
    }


  /**
   * Save Brand Reviews Settings
   *
   * @param brandId
   * @returns {deferred.promise|{then, always}}
   */
    self.saveBrandReviewsSettings = function(brandId, requestPayload) {

      var deferred = $q.defer();

      _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brand/reviews_settings/' + brandId, 'POST', requestPayload)
          .then(function(res) {
            if(res && res.data && res.data.status_code == 200) {
              deferred.resolve(res.data);
            }
            else{
              deferred.reject(res);
            }
          },
          function (err) {
            deferred.reject(err);
          });

      return deferred.promise;
    }


	/**
	 * Get user brands
	 *
	 * @returns {deferred.promise|{then, always}}
	 */
	self.getUserBrands = function (groupId) {

		var deferred = $q.defer();

		_protected.request('groups/' + groupId + '/brands', 'GET')
			.then(function (res) {
				if (res && res.data && res.data.data && res.data.status_code == 200) {
					deferred.resolve(res.data.data);
				}
				else {
					deferred.reject(res);
				}
			},
			function (err) {
				deferred.reject(err);
			});

		return deferred.promise;
	};

	/**
     * return brand admins
     * @param brandId
     * @returns {deferred.promise|{then}|{then, always}}
     */
    self.getBrandAdmins = function (brandId) {
		var deferred = $q.defer();

		_protected.request('brand_admin/' + brandId, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
	};

    self.getPublicLocales = function () {

        var deferred = $q.defer();
        var apiUrl = environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? environmentsConfig.get('tsCoreServers') : environmentsConfig.get('coreReaderAPIServers');

        _protected.request(apiUrl +'public/locales', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.locales || []);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserLocale = function () {

        var deferred = $q.defer();

        _protected.request('users/locales', 'GET')
            .then(function (res) {

                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data.locale || {});
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.saveUserLocale = function (localeCode) {

        var deferred = $q.defer();

        var payload = {
            locale: {
                code: localeCode
            }
        };

        _protected.request('users/locales', 'PUT', payload)
            .then(function (res) {

                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandDifferentialPaySettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/differential_pay', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.createDifferentialPayRule = function (brandId, rule) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'No brand id';
        }

        var payload = {
            'differential_pay_settings': rule
        }

        _protected.request('brands/' + brandId + '/settings/differential_pay', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch( function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.updateDifferentialPayRule = function (brandId, ruleId, rule) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'No brand id';
        }

        var payload = {
            'differential_pay_settings': rule
        }

        _protected.request('brands/' + brandId + '/settings/differential_pay/' + ruleId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch( function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    }

    self.deleteDifferentialPayRule = function (brandId, ruleId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'No brand id';
        }

        _protected.request('brands/' + brandId + '/settings/differential_pay/' + ruleId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }).catch( function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    }

    self.updateBrandDifferentialPaySettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/differential_pay', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.updateBrandMinorsSettings = function (brandId, payload) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/minors', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getBrandMinorsSettings = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/minors', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };
});
